import { styled } from '@linaria/react';

export const UserProfile = styled.div`
	display: flex;
	min-width: 25rem;
	justify-content: space-between;
	padding: 1.6rem;
`;

export const UserProfileLeft = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
`;

export const UserProfileRight = styled.div`
	position: relative;
	width: 4.8rem;
	height: 4.8rem;
	flex-shrink: 0;
	& > * {
		width: 100%;
		height: 100%;
	}
`;

export const SubscriptionDropdownElement = styled.button`
	display: flex;
	flex-direction: column;
	padding: 1.4rem 1.6rem;
	border-radius: var(--radius-xs);
	margin-right: 1.2rem;
	margin-bottom: 1.2rem;
	margin-left: 1.2rem;
	backdrop-filter: blur(14px);
	background-color: var(--color-white-xs);
	gap: 0.4rem;
`;
